/* eslint-disable */

import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'
import {goldInfo} from '@/api/user'

var timer = null

// 定時回傳在線心跳 取得當下金幣數量
export function refreshGold() {
  if (store.getters.token != null) {
    store.commit('SET_GOLD_INFO', {
      gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
      common_gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
      commission_gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
    })
    goldInfo().then(response => {
      store.commit('SET_GOLD_INFO', response.data.data)
    })
  }
}

// 正式環境線路不同 動態取url
export function getApiUrl() {
  // 決定api url
  if (store.getters.urlInfo.apiUrl) {
    return store.getters.urlInfo.apiUrl
  } else {
    return process.env.VUE_APP_BASE_API
  }
  // if (process.env.VUE_APP_BASE_API === '') {
  //   const currentUrl = new URL(window.location.href || document.location.href)
  //   // 正式環境可能走不同線路 依照前端域名決定
  //   let apiHost = currentUrl.host
  //   apiHost = apiHost.split('.')
  //   apiHost[0] = 'clientapi'
  //   return currentUrl.protocol + '//' + apiHost.join('.')
  // } else {
  //   return process.env.VUE_APP_BASE_API
  // }
}

export function setErrorMessage(response, errors) {
  errors.clear()
  if (response !== undefined && response.status !== undefined && response.status === 406) {
    let lastError = i18n.t('Bao.sorry_for_the_error')
    Object.keys(response.data.data).forEach(key => {
      lastError = response.data.data[key][0]
      errors.add({
        field: key,
        msg: lastError
      })
    })
  }
}

export function toErrorPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/error' }, () => {
  })
}

export function toMaintainPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/maintain' }, () => {
  })
}

export function toForbiddenPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/forbidden' }, () => {
  })
}

export function copyTextOfModal(modalBodyId, message) {

  var aux = document.createElement('input')

  // Assign it the value of the specified element
  aux.setAttribute('value', message)

  // Append it to the body
  // document.getElementById('addressDT').appendChild(aux)
  document.getElementById(modalBodyId).appendChild(aux)

  // Highlight its content
  aux.select()

  // Copy the highlighted text
  document.execCommand('copy')

  // Remove it from the body
  document.getElementById(modalBodyId).removeChild(aux)

  showNotice(i18n.t('Bao.copy_ok'))
}

export function copyText(message) {

  var aux = document.createElement('input')

  // Assign it the value of the specified element
  aux.setAttribute('value', message)

  // Append it to the body
  // document.getElementById('addressDT').appendChild(aux)
  document.body.appendChild(aux)

  // Highlight its content
  aux.select()

  // Copy the highlighted text
  document.execCommand('copy')

  // Remove it from the body
  document.body.removeChild(aux)

  showNotice(i18n.t('Bao.copy_ok'))
}

export function showNotice(message, func, close, isMessageLabel) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel
  }
  store.commit('SET_NOTICE_MESSAGE', data)
}

export function showConfirm(message, submitLabel, cancelLabel , submitFunc, cancelFunc) {
  const confirm = {
    message: message,
    submitLabel: submitLabel,
    cancelLabel: cancelLabel,
    submitFunc: submitFunc,
    cancelFunc: cancelFunc
  }
  console.log(confirm)
  store.commit('SET_CONFIRM_DIALOG', confirm)
}

export function stripTags(input) {
  var html = '<p>' + input + '</p>'
  var div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || div.innerText || ''
}

// 美洽客服
export function meiqiaInit(enterpriseId) {
  const externalFile = document.createElement('script')
  externalFile.setAttribute(
    'src',
    '/meiqia.js'
  )
  externalFile.async = true
  externalFile.onload = () => {
    _MEIQIA('entId', enterpriseId)
    _MEIQIA('manualInit')
    _MEIQIA('withoutBtn')
  }
  document.head.appendChild(externalFile)
}

export function isiOS() {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function notAppPage() {
  const url = window.location.href || document.location.href

  return url.includes('/web/') || url.includes('/agent') || url.includes('/error') || url.includes('/critical')
}

export function forceApp(currentRouteName, forceSetting) {
  if ((currentRouteName !== 'Register' && currentRouteName !== 'Share' && currentRouteName !== 'Error' && currentRouteName !== 'Critical') && forceSetting === 1 && detectMob() && !notAppPage()) {
    return true
  } else {
    return false
  }
}

export function newWindows(dataObject) {
  var newWindow = null
  if (dataObject.open_type === 'new') {
    return '_blank'
  }

  if (dataObject.open_type === 'self') {
    return '_self'
  }
}

export function loadBaseCss() {
  import('@/assets/css/vendors/bootstrap.css')
  // 須先引入
  import('@/assets/css/sportsbet.css')
  import('@/assets/style.css')
  // import('@/assets/css/cover.css')
  // import('@/assets/css/chat.css')
  // import('@/assets/css/color.css')
}
export function loadDynamicCss(theme) {
  if (theme === 'theme1') {
    import('assets/theme1/css/color.css')
    // import('assets/theme1/css/chatroom.css')
    // import('assets/theme1/css/content-nav.css')
    // import('assets/theme1/css/index.css')
    // import('assets/theme1/css/main.css')
    // import('assets/theme1/css/application_form.css')
    // import('assets/custom.css')
  } else if (theme === 'theme2') {
    import('@/assets/theme2/css/color.css')
    // import('@/assets/theme2/css/chatroom.css')
    // import('@/assets/theme2/css/content-nav.css')
    // import('@/assets/theme2/css/index.css')
    // import('@/assets/theme2/css/main.css')
    // import('@/assets/theme2/css/application_form.css')
    // import('@/assets/custom.css')
  } else if (theme === 'theme3') {
    import('@/assets/theme3/css/color.css')
  } else if (theme === 'theme4') {
    import('@/assets/theme4/css/color.css')
    // import('@/assets/theme4/css/special2.css')
  }

  import('@/assets/custom.css')


}

export function handleTokenUrl(urlString, token) {
  const url = new URL(urlString)
  const params = new URLSearchParams(url.search)
  params.delete('token')
  if (token) {
    params.append('token', token)
  } else {
    params.append('token', '')
  }
  return `${url.origin}${url.pathname}?${params.toString()}`
}
